// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7519aa77","633":"fb56511f"}[chunkId] + ".chunk.js";
};